module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318869.90366e54.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318869.pdf
// module id = 847
// module chunks = 0